/**
 * Widget Catalogue Type Other - Isolated Version
 *
 * A fork of CatalogueTypeOther that uses only eg-* prefixed components
 * without any Bootstrap dependencies.
 */

import _ from "lodash";
import { useEffect, useState } from "react";
import { hdlChg, hdlIsVal } from "../WidgetPreviewForm";
import { returnFormData, returnIsValid } from "../../components/Form/PreviewForm/formStarter";

export const WidgetCatalogueTypeOther = ({
  RenderInputComponent, // Pass WidgetRenderInput as a prop to avoid circular dependency
  entireSchema,
  entirePathSchema,
  setSchemaState,
  entireFormData,
  entirePathData,
  setFormData,
  entireIsValid,
  setIsValid,
  constraints,
  setConstraints,
  attachments,
  setAttachments,
  tryToNext,
  activeStep,
  parentValue,
  parentOrigin,
  lang,
  theme = 'light',
  formParams = {}
}) => {
  const [rerendering, setRerendering] = useState(false);

  const parentSchema = _.get(entireSchema, entirePathSchema);
  const endsWithOther = parentValue?.endsWith("type::other");

  const typeOtherInputs = parentSchema?.typeOther || [];

  useEffect(() => {
    if (rerendering) {
      setRerendering(false);
    }
  }, [rerendering]);

  useEffect(() => {
    changeSchema();
  }, [parentValue]);

  function changeSchema() {
    if (!rerendering && typeOtherInputs.length > 0) {
      if (endsWithOther) {
        let newDataTypeOther = Array.isArray(typeOtherInputs) && returnFormData(typeOtherInputs, `${parentOrigin}::typeOther`) || [];
        let newValidTypeOther = Array.isArray(typeOtherInputs) && returnIsValid(typeOtherInputs, lang) || [];
        hdlChg({ e: { target: { value: newDataTypeOther } }, params: { typeOther: newDataTypeOther }, entireFormData, entirePathData, setFormData });
        hdlIsVal({ errors: newValidTypeOther, entirePathDataWithKey: `${entirePathData}.typeOther`, entireIsValid, setIsValid });
      } else {
        hdlChg({ e: { target: { value: [] } }, params: { typeOther: [] }, entireFormData, entirePathData, setFormData });
        hdlIsVal({ errors: [], entirePathDataWithKey: `${entirePathData}.typeOther`, entireIsValid, setIsValid });
      }
    }
  }

  if (typeOtherInputs.length === 0 || !endsWithOther) return null;

  if (!RenderInputComponent) {
    console.warn('[Widget] RenderInputComponent not provided to WidgetCatalogueTypeOther');
    return null;
  }

  return (
    <>
      {typeOtherInputs.map((sch, idx) => (
        <RenderInputComponent
          key={`${parentOrigin}::typeOther::${idx}`}
          entireSchema={entireSchema}
          entirePathSchema={`${entirePathSchema}.typeOther.${idx}`}
          setSchemaState={setSchemaState}
          entireFormData={entireFormData}
          entirePathData={`${entirePathData}.typeOther.${idx}`}
          setFormData={setFormData}
          entireIsValid={entireIsValid}
          setIsValid={setIsValid}
          constraints={constraints}
          setConstraints={setConstraints}
          attachments={attachments}
          setAttachments={setAttachments}
          tryToNext={tryToNext}
          activeStep={activeStep}
          origin={`${parentOrigin}::typeOther::${idx}`}
          lang={lang}
          theme={theme}
          formParams={formParams}
        />
      ))}
    </>
  );
};

export default WidgetCatalogueTypeOther;
